import { render, staticRenderFns } from "./BotLayout.vue?vue&type=template&id=3d30f55f"
import script from "./BotLayout.vue?vue&type=script&lang=js"
export * from "./BotLayout.vue?vue&type=script&lang=js"
import style0 from "./BotLayout.vue?vue&type=style&index=0&id=3d30f55f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports